import axios from 'axios'
import config from '../apiConfig'
import url from '../baseUrl'
let baseUrl = url.salaryUrl



//模板文件上传
const $axiosTemplateAddFile = params => axios.post(baseUrl + '/contractTemplate/addFile', params );

// 查询模板列表
const $axiosGetTempLatePage = params => axios.get(baseUrl+'/contractTemplate/getTempLatePage', {params});

//获得易签宝上传pdf的编辑地址
const $axiosGetTemplateEditUrl = params => axios.get(baseUrl+'/contractTemplate/getTemplateEditUrl', {params});

//易签宝pdf被编辑修改后,调用此接口 更新模板字段信息
const $axiosSyncTemplateField = params => axios.get(baseUrl+'/contractTemplate/syncTemplateField', {params});

//模板签字区域
const $axiosGetTemplateField = params => axios.get(baseUrl+'/contractTemplateField/getTemplateField', {params});
//获取所有业务表的字段
const $axiosGetTempLateRelaSql = params => axios.get(baseUrl+'/contractBuzSql/getTempLateRelaSql', {params});
//获取所有业务表
const $axiosGetTemplateBuzSqlList = params => axios.get(baseUrl+'/contractBuzSql/getBuzSqlList', {params});

//获取模板字段的字典值
const $axiosGetTemplateAccountConfig = params => axios.get(baseUrl+'/contractTemplateField/getAccountConfig', {params});

//修改合同模板主表信息
const $axiosSaveOrUpdateTemplate = params => axios.post(baseUrl + '/contractTemplate/saveOrUpdateTemplate', params );

//修改合同模板主表信息
const $axiosBatchUpdateFieldConfig = params => axios.post(baseUrl + '/contractTemplateField/batchUpdateFieldConfig', params );

//合同流程信息查询
const $ajaxContractprocedureinfoGetPageList = params => axios.get(baseUrl + '/contractprocedureinfo/getPageList', {params} );
//签署人列表查询
const $ajaxEsignManagerGetPageList = params => axios.get(baseUrl + '/esignManager/getPageList', {params} );
//取消签署
const $ajaxCancelSignNew = params => axios.get(baseUrl + '/contractprocedureinfo/cancelSign', {params} );
//停/启用模板
const $ajaxdeleteTemplate = params => axios.get(baseUrl + '/contractTemplate/deleteTemplate', {params} );
//停/启用签署人
const $ajaxdeleteSign = params => axios.get(baseUrl + '/esignManager/deleteSign', {params} );
//查看签署地址
const $ajaxselectContractSignUrl = params => axios.get(baseUrl + '/contractprocedureinfo/getSignUrl', {params} );
export default {
    $axiosGetTempLatePage,
    $axiosGetTemplateField,
    $axiosTemplateAddFile,
    $axiosGetTemplateEditUrl,
    $axiosSyncTemplateField,
    $axiosGetTempLateRelaSql,
    $axiosGetTemplateBuzSqlList,
    $axiosGetTemplateAccountConfig,
    $axiosSaveOrUpdateTemplate,
    $axiosBatchUpdateFieldConfig,
    $ajaxContractprocedureinfoGetPageList,
    $ajaxEsignManagerGetPageList,
    $ajaxCancelSignNew,
    $ajaxdeleteTemplate,
    $ajaxdeleteSign,
    $ajaxselectContractSignUrl
}
